const leaders = [
  {
    img: '/img/team-vijay-akasapu.png',
    name: 'Vijay Akasapu',
    job: 'CEO',
    text: 'A pioneer in modern threat detection with 20+ years shaping the security landscape. As a founding member of Mandiant, he helped build the first generation of EDR technology, drawing on deep expertise from Foundstone and FireEye.',
    style: {
      backgroundSize: 'cover',
      backgroundPosition: '62% 30%'
    }
  },
  {
    img: '/img/julio.png',
    name: 'Julio Escobar',
    job: 'CFO',
    text: 'Three decades of experience as an innovator, executive, entrepreneur and policy maker. Founder and co-founder of two technology companies. Believes in talent and motivation to drive innovation.',
    style: {
      opacity: 0.8
    }
  },
  {
    img: '/img/team-eric-cornelius.png',
    name: 'Eric Cornelius',
    job: 'CTO',
    text: 'Two decades of hands-on engineering experience and technical leadership working in digital media, finance, and cybersecurity domains.',
    style: {
      backgroundSize: 'cover',
      backgroundPosition: 'center 22%'
    }
  }
];

export default leaders;

